<template>
  <div id="ask-question">

    <el-dialog
      title="提问"
      size="tiny"
      v-model="openModal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="modalClose"
      @open="modalOpen">

      <!-- 问题标题 -->
      <el-input
        type="textarea"
        class="question-title"
        :rows="2"
        :minlength="10"
        :maxlength="50"
        placeholder="请输入问题标题（至少10个字）"
        @change="questionInput(1)"
        v-model="questionAddParam.question">
      </el-input>
      <div class="question-title-num"><span>{{questionTitleNum}}</span>/50</div>

      <!-- 问题描述 -->
      <el-input type="textarea" class="question-description"
        :maxlength="1000"
        :autosize="{'minRows':6}"
        placeholder="描述得越详细越快得到解答哦~（选填）"
        @change="questionInput(2)"
        v-model="questionAddParam.description">
      </el-input>
      <div class="question-description-num"><span>{{questionDescriptionNum}}</span>/1000</div>

      <!-- 可搜可选输入框，搜索国家 -->
      <div class="country-search-title">
        <span class="red-star">*</span>提到的国家/地区<div class="country-num">（<span class="country-num-red">{{questionAddParam.visa_country_id_set.length}}</span>/8）</div>
      </div>
      <el-autocomplete
        class="country-search-input"
        v-model="inputCountryValue"
        :fetch-suggestions="countrySearch"
        placeholder="必填，最多8个"
        :trigger-on-focus="true"
        @select="countrySelect"
      ></el-autocomplete>

      <!-- 关联国家、地区 -->
      <div class="tags">
        <div class="tag" v-for="tag in countryNameArray" :key="tag">{{tag}}<img @click="handleClose(tag)" src="../../assets/imgs/QA/delete.png" /></div>
      </div>

      <el-button class="submit" type="primary" @click="questionAddSubmit()" :disabled="!questionAddParam.question">提交</el-button>

    </el-dialog>
  </div>
</template>

<script>
import Http from '@/libs/http';

import _ from 'lodash';

export default {
  name: 'askQuestion',
  components: {
  },
  props: {
    open: {
      type: Boolean,
      default: false,
      required: true,
    },
    countryId: {
      type: Number,
      required: true,
      default: 0,
    },
    countryName: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      openModal: this.open, // 对话框是否打开

      // 添加问题参数
      questionAddParam: {
        question: '',
        description: '',
        visa_country_id_set: [this.countryId],
      },
      countryNameArray: [this.countryName], // 关联的国家名称数组
      inputCountryValue: '', // 国家搜索框输入的内容
      allCountryDate: [], // 所有的国家、地区数据

      questionTitleNum: 0, // 提问标题字数
      questionDescriptionNum: 0, // 提问描述字数

    };
  },
  computed: {
  },
  watch: {
    countryId(newCountryId) {
      if (newCountryId) {
        this.questionAddParam.visa_country_id_set = [newCountryId];
      }
    },

    // 同步外部开关操作
    open() {
      this.openModal = this.open;
    },
  },
  methods: {

    // 打开对话框回调
    modalOpen() {
    },

    // 关闭对话框回调
    modalClose() {

      // 关闭对话框时清除数据
      this.questionAddParam = {
        question: '',
        description: '',
        visa_country_id_set: [this.countryId],
      };
      this.countryNameArray = [this.countryName];
      this.inputCountryValue = '';

      setTimeout(() => {
        this.$emit('modalClose');
      }, 200);
    },

    handleClose(tag) {
      this.countryNameArray.splice(this.countryNameArray.indexOf(tag), 1);
      this.questionAddParam.visa_country_id_set.splice(this.questionAddParam.visa_country_id_set.indexOf(tag), 1);
      // this.inputCountryValue = '';
    },

    // 添加问题提交
    questionAddSubmit() {
      if (this.questionAddParam.question.length < 10) {
        this.$message({
          message: '问题标题请输入至少10个字',
          type: 'warning',
        });
        return;
      }
      if (this.questionAddParam.visa_country_id_set && this.questionAddParam.visa_country_id_set.length < 1) {
        this.$message({
          message: '请选择国家/地区',
          type: 'warning',
        });
        return;
      }
      Http.post('/qa_question_add', this.questionAddParam).then(() => {
        this.questionTitleNum = 0;
        this.questionDescriptionNum = 0;
        this.$emit('modalClose');
        this.$emit('updateQuestionList');
        this.$message({
          message: '您的问题已提交成功~',
          type: 'success',
        });
      }).catch((e) => {
        if (e) console.log(e);
        this.$message({
          message: '提交失败，请稍后再试~',
          type: 'error',
        });
      });
    },

    // 取消添加问题
    cancel() {

    },

    /** 国家搜索
     * @param {String} queryString 输入框获取到用户输入的内容
     * @param {Function} cb 回调函数
     */
    countrySearch(queryString, cb) {
      const restaurants = this.allCountryDate;
      const results = queryString ? restaurants.filter(this.createCountryFilter(queryString)) : restaurants;
      cb(results);
    },

    // 过滤、搜索国家
    createCountryFilter(queryString) {
      return state => (state.country.indexOf(queryString.toLowerCase()) > -1);
    },

    // 将选择国家相关数据添加到对应数组中
    countrySelect(item) {
      if (this.questionAddParam.visa_country_id_set.length >= 8) {
        this.$message({
          message: '最多只能选择8个国家/地区哦~',
          type: 'error',
        });
        return;
      }
      const isAdd = _.find(this.questionAddParam.visa_country_id_set, el => el === item.id);
      if (isAdd) {
        this.$message({
          message: '已添加过该国家/地区',
          type: 'warning',
        });
      } else {
        this.countryNameArray.push(item.country);
        this.questionAddParam.visa_country_id_set.push(item.id);

        // 选择国家后清空输入框内容
        this.inputCountryValue = '';
      }
    },

    // 输入框字数显示
    questionInput(type) {
      if (type === 1) {
        this.questionTitleNum = this.questionAddParam.question ? this.questionAddParam.question.length : 0;
      } else if (type === 2) {
        this.questionDescriptionNum = this.questionAddParam.description ? this.questionAddParam.description.length : 0;
      }
    },

  },
  created() {

    // 获取国家数据
    Http.post('/sys/visa_country_total_query', {}).then((data) => {
      this.allCountryDate = data.page_data;

      // el-autocomplete 只识别 value 字段并在下拉列中显示
      this.allCountryDate.forEach((el) => {
        el.value = el.country;
      });
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";

#ask-question {
  .el-dialog {
    width: 600px;
    background-color: #fbfbfb;
    box-shadow: -1px -8px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    .el-dialog__header {
      padding: 0;
      border-bottom: 1px solid #f1f1f1;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .el-dialog__title {
        font-size: 16px;
        color: #333333;
      }
      .el-dialog__headerbtn {
        height: 50px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 18px;
        .el-dialog__close {
          color: #777777;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      .question-title {
        padding: 18px;
        background-color: #ffffff;
        border-bottom: 1px solid #f1f1f1;
        textarea {
          padding: 0px;
          height: 60px;
          border: none;
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          caret-color:#5e9be1;;
        }
      }
      .question-title-num {
        width: 40px;
        text-align: right;
        font-size: 12px;
        color: #aaaaaa;
        position: relative;
        bottom: 18px;
        left: 540px;
        span {
          color: #ff5a60;
        }
      }
      .question-description {
        padding: 18px;
        background-color: #ffffff;
        border-bottom: 1px solid #f1f1f1;

        /* 这个是为了去除问题、描述数字通过相对定位移走后原有位置留下的区域。 */
        margin-top: -13px;
        margin-bottom: -15px;

        textarea {
          padding: 0px;
          border: none;
          font-size: 14px;
          color: #333333;
          caret-color:#5e9be1; // 定义插入光标的颜色
        }
      }
      .question-description-num {
        width: 70px;
        text-align: right;
        font-size: 12px;
        color: #aaaaaa;
        position: relative;
        bottom: 4px;
        left: 510px;
        span {
          color: #ff5a60;
        }
      }
      .country-search-title {
        padding: 8px 0 0 20px;
        font-size: 14px;
        line-height: 38px;
        .red-star {
          color: #ff5a60;
        }
        .country-num {
          display: inline-block;
          color: #aaaaaa;
          .country-num-red{
            color: #ff5a60;
          }
        }
      }
      .country-search-input {
        width: 100%;
        height: 40px;
        padding: 0 20px;
        div{
          padding-left: 36px;
          border: 1px solid #e9e9e9;
          border-radius: 4px;
          background: url("../../assets/imgs/QA/search.png") no-repeat 10px center;
          input {
            width: 522px;
            height: 38px;
            border: none;
            padding: 0;
          }
        }
      }
      .tags {
        padding: 0 20px;
        .tag {
          display: inline-block;
          padding: 7px 19px;
          background-color: #ffffff;
          border-radius: 14px;
          border: solid 1px #5e9be1;
          font-size: 14px;
          color: #5e9be1;
          position: relative;
          margin-right: 20px;
          margin-top: 14px;
          &:first-of-type {
             margin-left: 0px;
          }
          img {
            position: absolute;
            cursor: pointer;
            height: 16px;
            width: 16px;
            top: -4px;
            right: -6px;
          }
        }
      }
      .submit {
        margin: 40px auto 20px;
        width: 280px;
        height: 40px;
        background-color: #5e9be1;
        border-radius: 20px;
        font-size: 16px;
        color: #ffffff;
        display: block;
        border: none;
      }
      .submit:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/ask-question.vue